import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`relative w-12 h-9 rounded-full border border-[color:var(--line-strong)] bg-[color:var(--surface-2)] transition-colors hover:border-brand/50 ${className}`}
    >
      <motion.span
        layout
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
        className="absolute top-1 w-7 h-7 rounded-full bg-gradient-to-br from-brand to-brand-deep grid place-items-center shadow"
        style={{ left: isDark ? "4px" : "calc(100% - 32px)" }}
      >
        {isDark ? <Moon size={13} className="text-ink" /> : <Sun size={13} className="text-white" />}
      </motion.span>
    </button>
  );
}
